// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QC Dashboard Styles */

.qc-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.qc-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.qc-header h1 {
  margin: 0 0 16px 0;
  font-size: 28px;
  font-weight: 600;
}

.header-controls {
  display: grid;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}

.health-status {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 14px;
}

.token-input {
  display: flex;
  align-items: center;
  gap: 12px;
}

.token-input label {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.token-input .input-field {
  flex: 1 1;
  max-width: 300px;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
}

/* Tabs */
.qc-tabs {
  display: flex;
  gap: 0;
  padding: 0;
  margin: 0;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-bottom: 2px solid #e5e7eb;
  max-width: 100%;
  overflow-x: auto;
}

.qc-tabs .tab {
  flex: 1 1;
  min-width: 150px;
  padding: 16px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
}

.qc-tabs .tab:hover {
  background: #f9fafb;
  color: #374151;
}

.qc-tabs .tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background: #f9fafb;
}

/* Content */
.qc-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

.tab-content {
  display: grid;
  gap: 24px;
}

.current-job {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.current-job h2 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: #1f2937;
}

/* History */
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.history-header h2 {
  margin: 0;
  font-size: 20px;
  color: #1f2937;
}

.job-history {
  display: grid;
  gap: 12px;
  max-height: 600px;
  overflow-y: auto;
}

.history-item {
  background: white;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.history-item-header {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.job-id {
  font-family: "Courier New", monospace;
  font-size: 11px;
  padding: 2px 6px;
  background: #f3f4f6;
  border-radius: 3px;
  flex: 0 0 auto;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-name {
  font-weight: 500;
  flex: 1 1;
  min-width: 150px;
}

.timing {
  font-size: 12px;
  color: #6b7280;
  padding: 2px 6px;
  background: #f0f9ff;
  border-radius: 3px;
}

.history-item-details {
  padding-top: 12px;
}

.history-item-details details {
  cursor: pointer;
}

.history-item-details summary {
  color: #667eea;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 0;
}

/* Status Badges */
.qc-dashboard .status {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.qc-dashboard .status-pending,
.qc-dashboard .status-processing {
  background: #fef3c7;
  color: #92400e;
}

.qc-dashboard .status-completed {
  background: #d1fae5;
  color: #065f46;
}

.qc-dashboard .status-failed {
  background: #fee2e2;
  color: #991b1b;
}

.qc-status {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.qc-passed {
  background: #d1fae5;
  color: #065f46;
}

.qc-failed {
  background: #fee2e2;
  color: #991b1b;
}

.error-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #fee2e2;
  color: #991b1b;
}

.findings-count {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #e0e7ff;
  color: #3730a3;
}

/* Buttons */
.btn-primary,
.btn-secondary,
.btn-danger,
.btn-warning,
.btn-small,
.btn-expand {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #667eea;
  color: white;
  width: 100%;
  padding: 12px 16px;
  font-size: 15px;
  margin-top: 20px;
}

.btn-primary:hover:not(:disabled) {
  background: #5568d3;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.btn-secondary {
  background: #e5e7eb;
  color: #374151;
}

.btn-secondary:hover {
  background: #d1d5db;
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}

.btn-warning {
  background: #f59e0b;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
}

.btn-expand {
  background: none;
  color: #667eea;
  padding: 8px 0;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
  margin-top: 12px;
}

/* Alerts */
.qc-dashboard .alert {
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 16px;
}

.qc-dashboard .alert-error {
  background: #fee2e2;
  color: #991b1b;
  border-left: 4px solid #dc2626;
}

.qc-dashboard .alert-success {
  background: #d1fae5;
  color: #065f46;
  border-left: 4px solid #10b981;
}

/* Empty State */
.qc-dashboard .empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* Polling Indicator */
.polling-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 4px;
  font-size: 12px;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .qc-header {
    padding: 16px;
  }

  .qc-header h1 {
    font-size: 20px;
  }

  .header-controls {
    grid-template-columns: 1fr;
  }

  .qc-tabs .tab {
    font-size: 12px;
    padding: 12px 16px;
    min-width: 120px;
  }

  .qc-content {
    padding: 16px;
  }

  .history-item-header {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/QC/QCDashboard.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D;wEACsE;AACxE;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;;;;;;EAME,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* QC Dashboard Styles */\n\n.qc-dashboard {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.qc-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 24px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.qc-header h1 {\n  margin: 0 0 16px 0;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.header-controls {\n  display: grid;\n  gap: 16px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.health-status {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.token-input {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.token-input label {\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.token-input .input-field {\n  flex: 1;\n  max-width: 300px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n/* Tabs */\n.qc-tabs {\n  display: flex;\n  gap: 0;\n  padding: 0;\n  margin: 0;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border-bottom: 2px solid #e5e7eb;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.qc-tabs .tab {\n  flex: 1;\n  min-width: 150px;\n  padding: 16px 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.qc-tabs .tab:hover {\n  background: #f9fafb;\n  color: #374151;\n}\n\n.qc-tabs .tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  background: #f9fafb;\n}\n\n/* Content */\n.qc-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.tab-content {\n  display: grid;\n  gap: 24px;\n}\n\n.current-job {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.current-job h2 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n  color: #1f2937;\n}\n\n/* History */\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.history-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #1f2937;\n}\n\n.job-history {\n  display: grid;\n  gap: 12px;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.history-item {\n  background: white;\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.history-item-header {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.job-id {\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  padding: 2px 6px;\n  background: #f3f4f6;\n  border-radius: 3px;\n  flex: 0 0 auto;\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.asset-name {\n  font-weight: 500;\n  flex: 1;\n  min-width: 150px;\n}\n\n.timing {\n  font-size: 12px;\n  color: #6b7280;\n  padding: 2px 6px;\n  background: #f0f9ff;\n  border-radius: 3px;\n}\n\n.history-item-details {\n  padding-top: 12px;\n}\n\n.history-item-details details {\n  cursor: pointer;\n}\n\n.history-item-details summary {\n  color: #667eea;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 4px 0;\n}\n\n/* Status Badges */\n.qc-dashboard .status {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.qc-dashboard .status-pending,\n.qc-dashboard .status-processing {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.qc-dashboard .status-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.qc-dashboard .status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.qc-status {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.qc-passed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.qc-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.error-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.findings-count {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  background: #e0e7ff;\n  color: #3730a3;\n}\n\n/* Buttons */\n.btn-primary,\n.btn-secondary,\n.btn-danger,\n.btn-warning,\n.btn-small,\n.btn-expand {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 15px;\n  margin-top: 20px;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #5568d3;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-primary:disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.btn-secondary:hover {\n  background: #d1d5db;\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #dc2626;\n}\n\n.btn-warning {\n  background: #f59e0b;\n  color: white;\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.btn-expand {\n  background: none;\n  color: #667eea;\n  padding: 8px 0;\n  width: 100%;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n  border-radius: 0;\n  margin-top: 12px;\n}\n\n/* Alerts */\n.qc-dashboard .alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.qc-dashboard .alert-error {\n  background: #fee2e2;\n  color: #991b1b;\n  border-left: 4px solid #dc2626;\n}\n\n.qc-dashboard .alert-success {\n  background: #d1fae5;\n  color: #065f46;\n  border-left: 4px solid #10b981;\n}\n\n/* Empty State */\n.qc-dashboard .empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Polling Indicator */\n.polling-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: #dbeafe;\n  color: #1e40af;\n  border-radius: 4px;\n  font-size: 12px;\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .qc-header {\n    padding: 16px;\n  }\n\n  .qc-header h1 {\n    font-size: 20px;\n  }\n\n  .header-controls {\n    grid-template-columns: 1fr;\n  }\n\n  .qc-tabs .tab {\n    font-size: 12px;\n    padding: 12px 16px;\n    min-width: 120px;\n  }\n\n  .qc-content {\n    padding: 16px;\n  }\n\n  .history-item-header {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
